import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseViolationRule, ViolationRule, ViolationRuleUpdateApiModel } from "src/app/models/api/governance/violationRule.model";
import { HttpService } from "../../http/http.service";

@Injectable({
    providedIn: "root",
})
export class ViolationRulesHttpService {
    /**
     * The policies base url
     * @private
     * @readonly
     */
    private readonly _baseUrl: string = "governance";

    constructor(private _httpService: HttpService) {}

    /**
     * TODO: to delete
     * Get the base violation rules
     * @returns A collection of default violation rules
     */
    public getBaseRules(): Observable<BaseViolationRule[]> {
        const url = `${this._baseUrl}/violationRules/default`;
        return this._httpService.get<BaseViolationRule[]>(url);
    }

    /**
     * Get violation rules of an integration
     * @param integrationId The integration id
     * @param policyId The policy id
     * @returns A collection of violation rules
     */
    public getViolationRules(integrationId: string, policyId: string): Observable<ViolationRule[]> {
        const url = `${this._baseUrl}/policies/integration/${integrationId}/policy/${policyId}/violationRules`;
        return this._httpService.get<ViolationRule[]>(url);
    }

    /**
     * Get governance rules (violations and detection) of an integration
     * @param integrationId The integration id
     * @param policyId The policy id
     * @returns A collection of violation rules
     */
    public getGovernanceRules(integrationId: string, policyId: string): Observable<ViolationRule[]> {
        const url = `${this._baseUrl}/policies/integration/${integrationId}/policy/${policyId}/rules`;
        return this._httpService.get<ViolationRule[]>(url);
    }

    /**
     * Get a single violation rule
     * @param integrationId The integration id
     * @param policyId The policy id
     * @param id The violation rule id
     * @returns The request violation rule
     */
    public getRule(integrationId: string, policyId: string, id: string): Observable<ViolationRule> {
        const url = `${this._baseUrl}/policies/integration/${integrationId}/policy/${policyId}/rule/${id}`;
        return this._httpService.get<ViolationRule>(url);
    }

    /**
     * Update a single violation rule
     * @param integrationId The integration Id
     * @param policyId The policy id
     * @param id The violation rule id
     * @param update A model will all the information to perform the update
     * @returns An empty string for success
     */
    public updateViolationRule(integrationId: string, policyId: string, id: string, update: ViolationRuleUpdateApiModel): Observable<string> {
        const url = `${this._baseUrl}/policies/integration/${integrationId}/policy/${policyId}/rule/${id}`;
        return this._httpService.put<string, ViolationRuleUpdateApiModel>(url, update);
    }

    /**
     * Reset a single violation rule
     * @param integrationId The integration Id
     * @param policyId The policy id
     * @param id The violation rule id
     * @returns An empty string for success
     */
    public resetViolationRule(integrationId: string, policyId: string, id: string): Observable<string> {
        const url = `${this._baseUrl}/policies/integration/${integrationId}/policy/${policyId}/rule/${id}/reset`;
        return this._httpService.put<string, ViolationRuleUpdateApiModel>(url);
    }
}
